import axios from 'axios';
import baseAPIUrl from '@/api/baseAPIUrl';
import baseUrl from '@/baseURL';

const filesManagerApi = axios.create({
    baseURL: baseAPIUrl,
});

/**  Interceptor de llamadas al back.
 * Se aplica a todas las llamadas que se hagan con esta instancia de axios, filesManagerApi
*/
filesManagerApi.interceptors.response.use(
    response => {
      // Comprueba si se intenta cargar otra web
      if (response.data?.redirect) {
        //Si la redirección es a index volvemos al login
        if(response.data.redirectCode === "index")
          window.location.assign(baseUrl); 
      }
      // Continue the normal execution
      return response;
    },
    error => {
      // Handle the error
      return Promise.reject(error);
    }
  );

export default filesManagerApi;